<div
  class="row-card grid-columns--6 button-colum-right text--small"
  (click)="isTabOpen = !isTabOpen"
  [ngClass]="isTabOpen ? 'row-card-clicked' : 'row-card-unclicked'"
  role="button"
>
  @for (data of promotedProperties; track $index) {
    <span style="overflow-wrap: anywhere;">
      {{ formatData(data.value) }}
    </span>
  }
  <span class="chevron" [ngClass]="isTabOpen ? 'bottom' : ''"></span>
</div>

<div
  class="accordion-tab text--small text--thin grid-columns--3"
  [ngClass]="isTabOpen ? 'accordion-tab-open' : 'accordion-tab-closed'"
>
  @for (field of dataFields; track $index) {
    <span>
      {{ field.name }}:
      <b>{{ formatData(field.value) }}</b>
    </span>
  }
</div>
